import { Power1, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const movingNeon: gsapTimelineFunc = (targets) => {
  return gsap
    .timeline({ defaults: { ease: Power1.easeOut } })
    .fromTo(
      targets,
      {
        duration: 0,
        opacity: 0,
        translateX: '50%',
        translateY: '-50%',
      },
      { duration: 0.1, opacity: 0, scaleY: '50%' }
    )
    .to(targets, { duration: 0.05, opacity: 1, scaleY: '200%' })
    .to(targets, { duration: 0.1, opacity: 0 })
    .to(targets, {
      duration: 0.05,
      opacity: 1,
      scaleY: '100%',
      translateX: '-50%',
      translateY: '50%',
    })
    .to(targets, { duration: 0.1, opacity: 1 })
    .to(targets, { duration: 0.2, opacity: 0 })
    .to(targets, { duration: 0.03, scaleY: '150%', opacity: 1 })
    .to(targets, {
      duration: 0.03,
      scaleY: '100%',
      opacity: 0,
      translateX: '200%',
      translateY: '-25%',
    })
    .to(targets, { duration: 0.03, opacity: 0 })
    .to(targets, {
      duration: 0.01,
      scaleY: '600%',
      scaleX: '600%',
      opacity: 1,
      translateX: '-50%',
      translateY: '30%',
    })
    .to(targets, {
      duration: 0.2,
      scaleY: '50%',
      scaleX: '30%',
      opacity: 0,
      translateX: '50%',
      translateY: '-30%',
    })
    .to(targets, {
      duration: 0.1,
      scaleY: '100%',
      scaleX: '100%',
      opacity: 1,
      translateX: '0%',
      translateY: '0%',
    });
};
